import React from 'react';
import { Switch, Route, RouteChildrenProps } from 'react-router';
import { Layout, Menu, Result, Button, Badge, Dropdown } from 'antd';
import { ClockCircleOutlined, DownOutlined, DoubleLeftOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import Menus from './routes';
import Logo from "../assets/images/qingcloud_new.svg";
import { getUserImg } from '../common/utils';
import './index.less';

const { SubMenu } = Menu;
const { Header, Content } = Layout;

const menus = Menus;

interface IProps extends RouteChildrenProps { }
interface IState {
  breadData: any[],
  currMenu: string,
  userinfo: any
}

class College extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      breadData: [], // 面包屑的数据
      currMenu: '/admin/home',
      userinfo: {}, // 用户信息
    }
  }
  // 
  componentDidMount() {
    // const { breadData } = this.state;
    // if (!breadData.length) {
    //   breadData.push({
    //     title: menus[0].title,
    //     url: menus[0].key
    //   }, {
    //     title: menus[0].child[0].title,
    //     url: menus[0].child[0].key
    //   })
    //   this.setState({
    //     breadData
    //   })
    // }
    let _menu = localStorage.getItem('adminMenu');
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    if (_menu) {
      this.setState({
        currMenu: _menu,
        userinfo
      })
    }
  }
  // 切换菜单
  changeMenu = (e: any) => {
    // const { keyPath } = e;
    // let breadData: any = [];
    // menus.map(item1 => {
    //   if (item1.key === keyPath[keyPath.length - 1]) {
    //     breadData.push({
    //       title: item1.title,
    //       url: item1.key
    //     })
    //   }
    //   item1.child.map(item2 => {
    //     if (item2.key === keyPath[0]) {
    //       breadData.push({
    //         title: item2.title,
    //         url: item2.key
    //       })
    //     }
    //     return item2;
    //   })
    //   return item1;
    // })
    // console.log(breadData);
    // this.setState({
    //   breadData
    // })
    // console.log(this.props);
    localStorage.setItem('adminMenu', e.key);
    this.setState({
      currMenu: e.key
    })
    this.props.history.push(e.key);
  }

  componentWillUnmount() {
    localStorage.removeItem('adminMenu');
  }

  handleGo = () => {
    window.open(window.location.origin + window.location.pathname, "_blank");
  }

  // 去首页
  goHome = () => {
    this.props.history.push('/');
  }

  render() {

    const menu = (
      <Menu>
        <Menu.Item>
          <div style={{ padding: 5 }} onClick={this.handleGo}>
            <DoubleLeftOutlined style={{ marginRight: 10 }} />
            <span>返回用户首页</span>
          </div>
        </Menu.Item>
      </Menu>
    );

    const { currMenu, userinfo } = this.state;
    const Empty = () => (<Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={<Button type="primary">Back Home</Button>}
    />)
    const _info = getUserImg(userinfo.crm_account_name);

    return (
      <div className="college_admin">
        <Layout className="allLayout">
          <Header
            className="college_admin_header"
            style={{ background: 'white', boxShadow: 'rgb(0 0 0 / 8%) 0px 6px 24px 0px', zIndex: 5 }}
          >
            <div className="header_left">
              <div className="logo" onClick={this.goHome}>
                <img src={Logo} alt="" />
                <span className="line">|</span>
                <span className="text">合作伙伴支持平台</span>
                <a className='workSpaceLink' onClick={(e)=>e.stopPropagation()} href="https://partner.quanxiangyun.com/qingcloud">
                  <ArrowLeftOutlined />
                    工作台
                </a>
              </div>
              <Menu mode="horizontal" className="header_menu"
                selectedKeys={[currMenu]}
                onClick={this.changeMenu}>
                {
                  menus.map(item1 => {
                    if (item1.child.length > 0) {
                      return (
                        <SubMenu
                          key={item1.key}
                          title={
                            <span className="submenu-title-wrapper">
                              {item1.title}
                              {item1.child.length > 0 && <DownOutlined />}
                            </span>
                          }
                        >
                          {item1.child.map(item2 => {
                            return !item2.disbaled && <Menu.Item key={item2.key}>{item2.title}</Menu.Item>
                          })}
                        </SubMenu>
                      )
                    } else {
                      return <Menu.Item key={item1.key}>{item1.title}</Menu.Item>
                    }
                  })
                }
              </Menu>
            </div>

            <Dropdown overlay={menu}>
              <div className="header_right">
                {/* <Badge dot>
                  <ClockCircleOutlined />
                </Badge> */}
                {/* <div className="img"><img src={UserImg} alt=""/></div> */}
                <div className="img" style={{ background: `${_info.color}` }}>{_info.name}</div>
              </div>
            </Dropdown>
          </Header>
          <Layout className='college_admin_cont'>
            {/* <Sider width={200} style={{ background: '#fff' }}>
              <Menu
                mode="inline"
                defaultSelectedKeys={[menus[0].child[0].key]}
                defaultOpenKeys={[menus[0].key]}
                style={{ height: '100%', borderRight: 0, paddingTop: 40}}
                // openKeys={['/coursemanage', '/testmanage']}
                onClick={this.changeMenu}
              >
                {
                  menus.map(item1 => {
                    return (
                      <SubMenu
                        key={item1.key}
                        title={
                          <span>
                            <Icon type={item1.icon} />
                            {item1.title}
                          </span>
                        }
                      >
                        {
                          item1.child.map(item2 => {
                            return (
                              <Menu.Item key={item2.key}>{item2.title}</Menu.Item>
                            )
                          })
                        }
                      </SubMenu>
                    )
                  })
                }
              </Menu>
            </Sider> */}
            <Layout>
              {/* <Breadcrumb style={{ margin: '16px 0' }}> */}
              {/* {
                  breadData.map(item => (<Breadcrumb.Item key={item.url}>{item.title}</Breadcrumb.Item>))
                } */}
              {/* <Breadcrumb.Item>课程管理</Breadcrumb.Item>
                <Breadcrumb.Item>我的课程</Breadcrumb.Item>
              </Breadcrumb> */}
              <Content
                style={{
                  // background: '#fff',
                  // padding: 24,
                  margin: 0
                }}
              >
                <Switch>
                  {
                    menus.map(item1 => {
                      if (item1.child.length > 0) {
                        return item1.child.map(item2 => {
                          return <Route exact={item2.exact} key={item2.key} path={item2.key} component={item2.component} />
                        })
                      } else {
                        return <Route exact={item1.exact} key={item1.key} path={item1.key} component={item1.component} />
                      }
                    })
                  }
                  {/* <Redirect from='/' to='/admin/home' /> */}
                  <Route path="*" component={Empty} />
                </Switch>
              </Content>
            </Layout>
          </Layout>
        </Layout>
      </div>
    )
  }
}

export default College;
